let fastWindowExpiresAt = 0;
const tooltipOpenListeners = new Map<symbol, (sourceId: symbol) => void>();

export function recordFastWindowHeartbeat(fastOpenWindowMs: number) {
  fastWindowExpiresAt = Date.now() + fastOpenWindowMs;
}

export function canUseFastWindow(fastOpenWindowMs: number) {
  if (!fastWindowExpiresAt) {
    return false;
  }
  if (Date.now() <= fastWindowExpiresAt) {
    return true;
  }
  resetFastWindowState();
  return false;
}

export function resetFastWindowState() {
  fastWindowExpiresAt = 0;
}

export function getFastWindowSnapshot() {
  return {
    expiresAt: fastWindowExpiresAt,
  };
}

export function registerTooltipOpenListener(instanceId: symbol, listener: (sourceId: symbol) => void) {
  tooltipOpenListeners.set(instanceId, listener);
  return () => {
    const existing = tooltipOpenListeners.get(instanceId);
    if (existing === listener) {
      tooltipOpenListeners.delete(instanceId);
    }
  };
}

export function notifyTooltipWillOpen(instanceId: symbol) {
  tooltipOpenListeners.forEach((listener, key) => {
    if (key === instanceId) {
      return;
    }
    listener(instanceId);
  });
}
